require("./snippets/accordion");
require("./snippets/product-quick-view-modal");
require("./qf/global_listeners");
//require("./qf/wishlist");
require("./qf/cart");
require("./qf/ModalController");

window.modalController = new ModalController()
//window.wishlist = new WishlistQf();
window.globalListeners = new GlobalListeners();
window.cart = new CartQf();